import { Alert, Box, Button } from '@ksyos/design-system';
import { useState } from 'react';
import type { UnavailableService } from '@common/interfaces/patientUnavailableServices';
import type { IPatientSearchResult } from './PatientSearchStartBar';
import { getDisplayName } from '../../../../../common/utils/getDisplayName';
import { translateKey } from '../../../../translate';
import { NullableStringBirthDate } from '../../../elements/NullableStringBirthDate';
import { ProcessStartWizardRow } from '../../../elements/ProcessStartWizard/ProcessStartWizardRow';
import { ProcessStartWizardText } from '../../../elements/ProcessStartWizard/ProcessStartWizardText';

interface IPatientResultBarProps {
    closedForAllReason?: string;
    disabled?: boolean;
    icon?: string;
    onStart: (patient?: any) => void | Promise<void>;
    patient: IPatientSearchResult;
    unavailableService?: UnavailableService;
}

export function PatientResultBar(props: IPatientResultBarProps) {
    const [isStartButtonDisabled, setIsStartButtonDisabled] = useState(false);

    return (
        <>
            <ProcessStartWizardRow
                actionComponent={
                    !props.unavailableService ? (
                        <Button
                            className="automation-startProcessButton"
                            color="secondary"
                            isDisabled={props.disabled || isStartButtonDisabled}
                            onClick={async () => await onStartClick(props.patient)}
                            variant="solid"
                        >
                            {translateKey('common.start')}
                        </Button>
                    ) : (
                        <Button hidden={true} />
                    )
                }
                icon={props.icon}
                label={getDisplayName(props.patient)}
                result={true}
                wrapChildren={true}
            >
                {props.patient.gender && (
                    <ProcessStartWizardText value={translateKey(`genderEnum.${props.patient.gender}`)} />
                )}
                {props.patient.identifierSocialSecurity && (
                    <ProcessStartWizardText
                        value={`${translateKey('patient.identifierSocialSecurity')}: ${
                            props.patient.identifierSocialSecurity
                        }`}
                    />
                )}
                <NullableStringBirthDate value={props.patient.birthDate} />
            </ProcessStartWizardRow>
            {props.unavailableService && !props.closedForAllReason && (
                <Box
                    pb={6}
                    px={6}
                >
                    <Alert
                        appearance="warning"
                        noMargin={true}
                    >
                        {translateKey(
                            `unavailableServices.${props.unavailableService.serviceCode.toLowerCase()}.${
                                props.unavailableService.reason
                            }.alertAndTooltip`
                        )}
                    </Alert>
                </Box>
            )}
        </>
    );

    async function onStartClick(patient: IPatientSearchResult) {
        setIsStartButtonDisabled(true);
        await props.onStart({ patient });
    }
}
